import { GetRunEventsActionEnum, RunEventDTO, SyncRunResultDTO, SyncRunResultDTOStatusEnum } from "@app/api/generated";
import { EVENTS_PAGE_SIZE, getRunById, getRunEvents } from "@app/modules/product-page-sync/product-page-sync-api";
import { IRunDetailSource } from "@app/util/use-run-detail";

/** What the shared run-detail hook needs to show a product-page sync run. */
export const SYNC_RUN_DETAIL_SOURCE: IRunDetailSource<SyncRunResultDTO, RunEventDTO, GetRunEventsActionEnum> = {
  getRun: getRunById,
  getEvents: getRunEvents,
  eventsPageSize: EVENTS_PAGE_SIZE,
  isRunning: (run) => run.status === SyncRunResultDTOStatusEnum.RUNNING
};
